import script from "./VVVEarlyPayoutNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVEarlyPayoutNotification.vue?vue&type=script&setup=true&lang=js"

import "./VVVEarlyPayoutNotification.vue?vue&type=style&index=0&id=76fab309&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76fab309"]])

export default __exports__